import classNames from "classnames";
import React, { ReactElement } from "react";
import TimeAgo from "react-timeago";
import { TicketPriority, TicketStatus, useGetTicketsByCreatorQuery } from "../../__generated__/api";
import useRouting, { Link } from "../../contexts/Routing";
import { useTheme } from "../../contexts/Theme";
import { NoDataOrError } from "../../pages/error/Error";
import Loading from "../loading/Loading";
import Styles from "./ListTickets.module.scss";

const LOADING_TICKETS = [
    {
        id: 1,
        ticketNumber: 111,
        subject: "loading...",
        createdDate: new Date(),
        priority: TicketPriority.Medium,
        status: TicketStatus.Open,
    },
    {
        id: 2,
        ticketNumber: 222,
        subject: "loading...",
        createdDate: new Date(),
        priority: TicketPriority.Medium,
        status: TicketStatus.Open,
    },
    {
        id: 3,
        ticketNumber: 333,
        subject: "loading...",
        createdDate: new Date(),
        priority: TicketPriority.Medium,
        status: TicketStatus.Open,
    },
];

interface Props {
    id: string;
    excludeId?: string;
}

export default function ListTickets({ id, excludeId }: Props): ReactElement {
    const { data, error, loading } = useGetTicketsByCreatorQuery({ variables: { id } });
    const { Paths } = useRouting();
    const theme = useTheme();

    if (loading && !theme.isV3) {
        return <Loading />;
    }
    let tickets = data?.tickets
        .sortByDescending(ticket => new Date(ticket.createdDate).getTime())
        .filter(ticket => ticket.chatId && ticket.chatId !== excludeId && ticket.id !== excludeId);
    if (!theme.isV3 && (error || !tickets)) {
        return <NoDataOrError error={error} />;
    }

    if (loading && !tickets) {
        tickets = LOADING_TICKETS;
    }

    return (

        <div className={classNames(Styles["ticket-list"], "list-group list-group-flush", loading ? "loading" : "")}>
            {tickets?.map(ticket => {
                const linkClasses = ["list-group-item list-group-item-action text-gray-800 w-100 d-flex gap-1"];
                linkClasses.push(Styles["ticket-item"]);
                linkClasses.push(Styles[`ticket-item-${(ticket.priority ?? TicketPriority.Medium).toLowerCase()}`]);

                const date = new Date(ticket.createdDate);
                return (
                    <Link
                        to={Paths.AGENT_CHAT}
                        params={{
                            chatId: ticket.ticketNumber ?? ticket.chatId ?? ticket.id,
                        }}
                        className={theme.isV3 ? Styles["user-ticket-item"] : linkClasses.join(" ")}
                        key={ticket.id}
                    >

                        <span className={theme.isV3 ? Styles["user-ticket-item-id"] : "text-light"}>
                            #
                            {ticket.ticketNumber}
                        </span>
                        <span className={theme.isV3 ? Styles["user-ticket-item-title"] : "flex-grow-1"}>
                            {ticket.subject}
                        </span>

                        <small className={Styles["user-ticket-item-time"]}>
                            <TimeAgo
                                date={date}
                                minPeriod={60}
                                title={`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`}
                            />
                        </small>
                    </Link>
                );
            })}

        </div>

    );
}

ListTickets.defaultProps = {
    excludeId: undefined,
};
